import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultPage from './Pages/DefaultPage';
import WizardPage from './Pages/WizardPage';

const DashboardAdvisorsRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:coBrandID/wizard`}>
                <WizardPage />
            </Route>
            <Route default>
                <DefaultPage />
            </Route>
        </Switch>
    );
};

export default DashboardAdvisorsRouter;
